import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { UserAssignedTasksContext, UserAssignedTasksContextProvider, } from "../../../providers/UserAssignedTasksContextProvider";
import { PageContentWrap, PageTitle, PageWrap } from "../Page/Page";
import { UserTasks } from "./UserTasks";
function UserTasksPage() {
    return (_jsx(UserAssignedTasksContextProvider, { children: _jsx(UserTaskPageContent, {}) }));
}
function UserTaskPageContent() {
    const { state: { loading }, loadAssignedTasks, } = useContext(UserAssignedTasksContext);
    return (_jsx(PageWrap, { loading: loading, onRefresh: loadAssignedTasks, children: _jsxs(PageContentWrap, { children: [_jsx(PageTitle, { description: __("Tasks that are assigned to you", "quicktasker"), children: __("Assigned tasks", "quicktasker") }), _jsx(UserTasks, {})] }) }));
}
export { UserTasksPage };
